import React, { useState } from 'react'
import { SigurPopover } from './SigurPopover'

/**
 * Иконка «i» для обязательного поля с поповером при наведении (вместо title).
 */
export function RequiredFieldPopover() {
  const [visible, setVisible] = useState(false)

  return (
    <SigurPopover
      visible={visible}
      placement="top"
      className="sigur-required-field-popover-wrapper"
      trigger={
        <span
          onMouseEnter={() => setVisible(true)}
          onMouseLeave={() => setVisible(false)}
          role="img"
          aria-label="Обязательное поле"
        >
          <i className="ti ti-info-circle sigur-required-field-icon" aria-hidden />
        </span>
      }
    >
      <span className="sigur-required-field-popover-content">Обязательное поле</span>
    </SigurPopover>
  )
}
